export const defaultTheme = {
    '--mark-background': '#ffe58f',
    '--selection-bg-color': 'rgba(46, 170, 220, 0.5)',
    '--selection-text-color': 'black',
    '--table-border': 'rgba(55, 53, 47, 0.09)',
    '--toolbar-btn-hover': '#eee',
    '--toolbar-btn-active': '#fff',
}
export const contentstackTheme = {
    '--mark-background': 'transparent',
    '--selection-bg-color': '#3390FF',
    '--selection-text-color': '#fff',
    '--table-border': '#eeeeee',
    '--toolbar-btn-hover': '#eee',
    '--toolbar-btn-active': '#fff',
}

export const darkTheme = {
    '--mark-background': '#4d4d00',
    '--selection-bg-color': 'darkgrey',
    '--selection-text-color': '#fff',
    '--table-border': '#bcbdbe',
    '--toolbar-btn-hover': '#34373C',
    '--toolbar-btn-active': '#393C43',
}